import { apiClient } from "../lib/api";

export const payrollAdminPackageApi = {
  validate: (periodId) => apiClient.get(`/payroll/periods/${periodId}/admin-package/validate`),
  generate: (periodId, options) => apiClient.post(`/payroll/periods/${periodId}/admin-package`, options),
  getDownloadUrl: (periodId) => `${apiClient.defaults.baseURL}/payroll/periods/${periodId}/admin-package`,
};
